module.exports = __webpack_public_path__ + "img/pic3.0cfc33b3.png";